import scrollStore from '../scroll/scroll.store';


window.dataLayer = window.dataLayer || [];
function gtag() {dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'GTM-57P3GLV');


document.getElementById('yota-logo').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / NAVIGATIONS', 'useNavigations / [logo] / clickLink', 'Логотип')
})
document.getElementById('morf-link-1').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / CONVERSIONS', 'conversionStep / [cards] / submit', 'Купить / Застолье / 0.3 wETH')
})
document.getElementById('morf-link-2').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / CONVERSIONS', 'conversionStep / [cards] / submit', 'Купить / Случай в парке / 0.3 wETH')
})
document.getElementById('morf-link-3').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / CONVERSIONS', 'conversionStep / [cards] / submit', 'Купить / Вид на купе / 0.3 wETH')
})
document.getElementById('morf-link-4').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / CONVERSIONS', 'conversionStep / [cards] / submit', 'Купить / Майские / 0.3 wETH')
})
document.getElementById('morf-link-5').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / CONVERSIONS', 'conversionStep / [cards] / submit', 'Купить / Яма на дороге / 0.3 wETH')
})
document.getElementById('morf-link-6').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / CONVERSIONS', 'conversionStep / [cards] / submit', 'Купить / Бабушки / 0.3 wETH')
})
document.getElementById('morf-link-7').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / CONVERSIONS', 'conversionStep / [cards] / submit', 'Купить / Панелька / 0.3 wETH')
})
document.getElementById('morf-link-8').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / CONVERSIONS', 'conversionStep / [cards] / submit', 'Купить / Фасад / 0.3 wETH')
})
document.getElementById('morf-link-9').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / CONVERSIONS', 'conversionStep / [cards] / submit', 'Купить / Очередь / 0.3 wETH')
})

document.getElementById('shareBtn').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / CONVERSIONS', 'conversionStep / [footer] / submit', 'Поделиться проектом')
})

document.getElementById('order-sim').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / CONVERSIONS', 'conversionStep / [footer] / submit', 'Заказать SIM-карту')
})
document.getElementById('fb').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / ACTIONS', 'makeActions / [popup] / clickSocial', 'facebook')
})
document.getElementById('insta').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / ACTIONS', 'makeActions / [popup] / clickSocial', 'instagram')
})
document.getElementById('tw').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / ACTIONS', 'makeActions / [popup] / clickSocial', 'twitter')
})
document.getElementById('vk').addEventListener('click', () => {
    gtag('event', 'click', 'crypto-web [prod] / ACTIONS', 'makeActions / [popup] / clickSocial', 'vk')
})







window.addEventListener('scroll', onScroll);
window.addEventListener('resize', onResize);

let heightDocument;
let percent20 = false;
let percent40 = false;
let percent60 = false;
let percent80 = false;
let percent100 = false;

setTimeout(onResize, 0)


function onResize() {
    heightDocument = document.body.getBoundingClientRect().height - window.innerHeight
}

function onScroll() {
    const scrolled = scrollStore.getData().top;

    if ((scrolled > heightDocument * .2) && (!percent20)) {
        percent20 = true
        gtag('event',
            'crypto-web [prod] / NAVIGATIONS',
            'useNavigations / [scrolling] / scroll',
            '20%');
    }
    if ((scrolled > heightDocument * .4) && (!percent40)) {
        percent40 = true
        gtag('event',
            'crypto-web [prod] / NAVIGATIONS',
            'useNavigations / [scrolling] / scroll',
            '40%');
    }
    if ((scrolled > heightDocument * .6) && (!percent60)) {
        percent60 = true
        gtag('event',
            'crypto-web [prod] / NAVIGATIONS',
            'useNavigations / [scrolling] / scroll',
            '60%');
    }
    if ((scrolled > heightDocument * .8) && (!percent80)) {
        percent80 = true
        gtag('event',
            'crypto-web [prod] / NAVIGATIONS',
            'useNavigations / [scrolling] / scroll',
            '80%');
    }
    if ((scrolled > heightDocument * .98) && (!percent100)) {
        percent100 = true
        gtag('event',
            'crypto-web [prod] / NAVIGATIONS',
            'useNavigations / [scrolling] / scroll',
            '100%');
    }
}

